import { render, staticRenderFns } from "./TasksCounter.vue?vue&type=template&id=23653c34&scoped=true"
import script from "./TasksCounter.vue?vue&type=script&setup=true&lang=ts"
export * from "./TasksCounter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TasksCounter.vue?vue&type=style&index=0&id=23653c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23653c34",
  null
  
)

export default component.exports